//#region IMPORTS
import { PROMO_TAB, PromoTab } from "./PromosTabs";
import { promosSelectors } from "../../features/promos/promosSlice";
import { useAppSelector } from "../../store/configureStore";
import { useHistory } from "react-router-dom";
import { Promo } from "../../models/promo";
import useVisibleWeekTemplates from "../../hooks/useVisibleWeekTemplates";
import PromosPageStaticItem from "./PromosPageStaticItem";
import PromosPageItem from "./PromosPageItem";
import useBasketGate from "../../hooks/useBasketGate";
//#endregion

//#region INTERFACE
interface Props {
  overWriteTransSmartHandler: (promo: Promo) => void;
  refreshTransmartHandler: (promo: Promo) => void;
  setProjectToDelete: (promo: Promo) => void;
  setProjectToClear: (promo: Promo) => void;
  setProjectToEdit: (promo: Promo, uploadData: boolean) => void;
  activeTab: PromoTab;
  isPicker: boolean;
  isAdmin: boolean;
  hqTeam: boolean;
}
//#endregion

export default function PromosPageItems({
  overWriteTransSmartHandler,
  refreshTransmartHandler,
  setProjectToDelete,
  setProjectToClear,
  setProjectToEdit,
  activeTab,
  isPicker,
  isAdmin,
  hqTeam,
}: Props) {
  //#region SETUP
  // Router
  const history = useHistory();

  // Redux
  const { basket } = useAppSelector((state) => state.basket);
  const promos = useAppSelector(promosSelectors.selectAll);
  const currentPromo = useAppSelector(
    (state) => basket && promosSelectors.selectById(state, basket.promo_id)
  );

  // The active "Week" templates this role may see — same source of truth as the
  // tab bar's disabled state (see useVisibleWeekTemplates).
  const { templates: visibleWeekTemplates } = useVisibleWeekTemplates();

  // Cross-basket gate: block week-order navigation when promo basket is active
  const { guardInstoreAction, promoActive } = useBasketGate();
  //#endregion

  //#region RENDER
  // The two kinds used to sit in one list (week templates on top, projects
  // below); they are now split over the tabs.
  return (
    <ul className="divide-y divide-gray-100">
      {activeTab === PROMO_TAB.nonPromo
        ? visibleWeekTemplates.map((template) => (
            <PromosPageStaticItem
              key={template.id}
              template={template}
              isAdmin={isAdmin}
              hqTeam={hqTeam}
              viewHandler={() => history.push(`/promos/instore/${template.id}`)}
              editHandler={() =>
                history.push(`/instoretemplates/${template.id}`)
              }
              orderHandler={guardInstoreAction(() =>
                history.push(`/promos/instore/${template.id}`),
              )}
              orderDisabled={promoActive}
            />
          ))
        : promos.map((promo) => (
            <PromosPageItem
              overWriteTransSmartHandler={() =>
                overWriteTransSmartHandler(promo)
              }
              refreshTransmartHandler={() => refreshTransmartHandler(promo)}
              setProjectToDelete={() => setProjectToDelete(promo)}
              setProjectToClear={() => setProjectToClear(promo)}
              setProjectToEdit={() => setProjectToEdit(promo, false)}
              promoInBasket={currentPromo}
              uploadHandler={() => setProjectToEdit(promo, true)}
              isPicker={isPicker}
              isAdmin={isAdmin}
              hqTeam={hqTeam}
              promo={promo}
              key={promo.id}
            />
          ))}
    </ul>
  );
  //#endregion
}
